import * as React from 'react';
import { Link, usePage } from '@inertiajs/react';
import { route } from '../../utils/route';
import { assetUrl } from '../../utils/assetUrl';

export function GiftBanner(): React.ReactElement {
  const { cdnUrl } = usePage<{ cdnUrl: string }>().props;
  const img = assetUrl(cdnUrl, '/img/gift/hero-box.webp');

  return (
    <section className="px-4 py-8 sm:py-12">
      <div className="mx-auto max-w-6xl">
        <Link
          href={route('gift.index')}
          className="group relative block overflow-hidden rounded-2xl bg-gradient-to-r from-[#e8f5e3] to-[#f6faf4] sm:rounded-3xl"
        >
          <div className="relative flex flex-col items-center gap-6 px-6 py-8 sm:flex-row sm:gap-10 sm:px-10 sm:py-10">
            {/* Copy */}
            <div className="flex-1 text-center sm:text-left">
              <span className="mb-2 inline-block rounded-full bg-green-600 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-white">
                Nuevo
              </span>
              <h2 className="mt-2 text-2xl font-extrabold leading-tight text-gray-900 sm:text-3xl">
                Regalá frescura
              </h2>
              <p className="mt-2 text-base leading-relaxed text-gray-600 sm:max-w-sm sm:text-lg">
                Sorprendé a alguien especial con frutas y verduras frescas directo a su puerta.
              </p>
              <span className="mt-4 inline-flex items-center gap-2 rounded-full bg-green-600 px-6 py-2.5 text-sm font-semibold text-white shadow-md transition-all group-hover:bg-green-700 group-hover:shadow-lg">
                Regalar ahora
                <svg className="h-4 w-4 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </div>

            {/* Image */}
            <div className="relative h-44 w-44 flex-shrink-0 sm:h-52 sm:w-52">
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-green-100 to-amber-50 rotate-3" />
              <img
                src={img}
                alt="Canasta de regalo con frutas y verduras"
                className="relative z-10 h-full w-full rounded-2xl object-cover shadow-xl -rotate-2"
                loading="lazy"
              />
              <div className="absolute -bottom-2 -right-2 z-20 flex h-12 w-12 items-center justify-center rounded-xl bg-white text-2xl shadow-md">
                🎁
              </div>
            </div>
          </div>

          {/* Decorative blob */}
          <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-green-200/30 blur-3xl" />
        </Link>
      </div>
    </section>
  );
}
